import React from 'react'
import { styled } from '@mui/material/styles'
import { Box } from '@mui/material'
import Link from 'next/link'
import { ArrowBack } from 'src/components/icons'

const StyledLink = styled(Link)`
  display: flex;
  color: ${({ theme }) => theme.custom.colors.common.black};

  &:active,
  &:hover {
    background-color: transparent;
  }
`

const StyledBox = styled(Box)`
  position: relative;

  ${({ theme }) => theme.breakpoints.up('sm')} {
    padding-right: 24px;
    margin-right: 18px;
  }

  &:after {
    position: absolute;
    right: -2px;
    top: -6px;
    display: block;
    background-color: ${({ theme }) => theme.custom.colors.common.black};
    width: 2px;
    height: 36px;

    ${({ theme }) => theme.breakpoints.up('sm')} {
      content: '';
    }
  }
`

interface BackButtonProps {
  to: string
}

export const BackButton: React.FC<BackButtonProps> = (props) => {
  const { to } = props
  return (
    <StyledBox>
      <StyledLink href={to}>
        <ArrowBack />
      </StyledLink>
    </StyledBox>
  )
}
